var _line, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBadge1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 52,
    viewBox: "0 0 58 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 28.5742,
    y1: 1.32642,
    x2: 28.5742,
    y2: 19.4868,
    stroke: "#FF99BE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.2096 3.31062L34.9515 3.62681L35.2096 3.943L37.504 6.75362H28.6953V1C28.6953 0.723858 28.9192 0.5 29.1953 0.5H37.504L35.2096 3.31062Z",
    fill: "#FFFDC3",
    stroke: "#FF99BE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.42818 30.9816L11.5667 19.2426C11.9655 18.7808 12.6814 18.7808 13.0803 19.2427L23.2182 30.9816C23.7778 31.6295 23.3175 32.6352 22.4614 32.6352H2.18499C1.32888 32.6352 0.868596 31.6295 1.42818 30.9816Z",
    fill: "white",
    stroke: "#FF99BE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2688 31.4816L40.2504 15.8226C40.648 15.3773 41.3447 15.3773 41.7423 15.8226L55.7231 31.4816C56.2984 32.126 55.841 33.1476 54.9771 33.1476H27.0147C26.1508 33.1476 25.6934 32.126 26.2688 31.4816Z",
    fill: "#FFFDC3",
    stroke: "#FF99BE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.18795 34.6888L27.9726 9.961C28.3708 9.50905 29.0752 9.50906 29.4733 9.96102L51.2567 34.6889C51.8257 35.3347 51.3671 36.3499 50.5064 36.3499H6.9383C6.07755 36.3499 5.61896 35.3347 6.18795 34.6888Z",
    fill: "#FF99BE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4581 37.6153C29.3434 41.9242 36.0059 46.3958 40.5684 48.9468C41.5098 49.4732 41.1321 51.0753 40.0536 51.0753H23.3584C22.5689 51.0753 21.855 50.6116 21.5786 49.8721C20.5845 47.2125 18.5478 40.7035 20.3918 36.081C22.1596 31.6496 27.2055 29.2115 28.9092 25.5849C29.7398 23.8167 29.0619 21.1927 28.4815 19.564C28.2338 18.8688 28.7376 18.0878 29.4757 18.0878H29.7002C30.0821 18.0878 30.4301 18.3058 30.6026 18.6465C31.9359 21.282 33.1868 23.2432 33.1868 26.3895C33.1868 29.7541 29.559 33.8263 29.4581 37.6153Z",
    fill: "white",
    stroke: "#FF99BE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1028 51.0319C28.0706 48.0411 25.1476 44.7748 24.781 39.7679C24.357 33.9767 30.4149 30.1935 30.9762 26.2511",
    stroke: "#FF99BE",
    strokeLinecap: "round",
    strokeDasharray: "4 4"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge1);
export default __webpack_public_path__ + "static/media/Badge1.b219de3d2a649d0db9810ab41b18effe.svg";
export { ForwardRef as ReactComponent };